import { canv } from "@/canv/global";
import type { ShapeTextPart } from "@/shapeStorage/shapes/shape";
import { Shape } from "@/shapeStorage/shapes/shape";
import { getNewStartYByHeight } from "@/shapeStorage/utils";

export class ShapeNode extends Shape {
    width = 200;
    height = 153;

    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 7) / 8 - 2 * horizontalPadding;
        const allowedHeight = height - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + (width * 7) / 8 / 2 - textPart.width / 2;

        textPart.startY = getNewStartYByHeight(
            textPart,
            y,
            height,
            height * 1.25,
            height / 5,
            verticalPadding,
        );

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, w: number, h: number) {
        canv.ctx.beginPath();
        canv.ctx.moveTo(x + w, y);
        canv.ctx.lineTo(x + (w * 4) / 22, y);
        canv.ctx.lineTo(x, y + (h * 3.5) / 17);
        canv.ctx.lineTo(x, y + h);
        canv.ctx.lineTo(x + (w * 18) / 22, y + h);
        canv.ctx.lineTo(x + w, y + (h * 13.5) / 17);
        canv.ctx.lineTo(x + w, y);
        canv.ctx.lineTo(x + (w * 18) / 22, y + (h * 3.5) / 17);
        canv.ctx.lineTo(x + (w * 18) / 22, y + h);
        canv.ctx.moveTo(x, y + (h * 3.5) / 17);
        canv.ctx.lineTo(x + (w * 18) / 22, y + (h * 3.5) / 17);
        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 7.12663V20.5H19.2556M1 7.12663L19.2556 7.1627M1 7.12663L4.9107 3.5H23M23 3.5V17.2169L19.2556 20.5M23 3.5L19.2556 7.1627M19.2556 7.1627V20.5"
                stroke="${stroke}" stroke-linejoin="round"/>
            </svg>
        `;
    }
}
